import { CountryCode } from '../../types/CountryCode';
import { AuthenticationData } from './authenticationTypes';

export const getAccessTokenFromCodeService = async (
    oAuthBaseUrl: string,
    apiKey: string,
    code: string | undefined,
): Promise<AuthenticationData> => {
    const url = `${oAuthBaseUrl}/get_access_token`;
    const request = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            apikey: apiKey,
        },
        body: JSON.stringify({
            code,
        }),
    };
    return fetch(url, request).then((response) => response.json());
};

export const refreshAccessTokenService = async (
    oAuthBaseUrl: string,
    apiKey: string,
    refreshToken: string,
    scope: string | undefined,
): Promise<AuthenticationData> => {
    const url = `${oAuthBaseUrl}/refresh_access_token`;
    const request = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            apikey: apiKey,
        },
        body: JSON.stringify({
            refreshToken,
            scope,
        }),
    };
    return fetch(url, request).then((response) => response.json());
};

export const revokeRefreshTokenService = async (
    oAuthBaseUrl: string,
    apiKey: string,
    refreshToken: string,
    scope: string | undefined,
): Promise<void> => {
    const url = `${oAuthBaseUrl}/revoke_token`;
    const request = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            apikey: apiKey,
        },
        body: JSON.stringify({
            refreshToken,
            scope,
        }),
    };
    return fetch(url, request).then((_response) => Promise.resolve());
};

export const getAuthorizationUrlService = async (
    oAuthBaseUrl: string,
    apiKey: string,
    countryCode: CountryCode,
    redirectUrl: string,
    state: string,
    authenticationScope?: string,
    governmentId?: string,
): Promise<string> => {
    const url = `${oAuthBaseUrl}/init`;
    const request = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            apikey: apiKey,
        },
        body: JSON.stringify({
            countryCode,
            scope: authenticationScope,
            redirectUrl,
            state,
            governmentId,
        }),
    };
    return fetch(url, request).then((response) => {
        if (!response.ok) {
            return Promise.reject(new Error('Could not initiate authentication, got error ' + response.status));
        }
        return response.text();
    });
};

// Isolated in its own export so tests can mock it -- jsdom's window.location.replace is a non-configurable
// method in this project's jsdom version and can't be jest.spyOn'd or overridden directly.
export const redirectToAuthorizationUrl = (authorizationUrl: string) => {
    window.location.replace(authorizationUrl);
};
